/**
 * @generated SignedSource<<35c2bcb8915a946cd54acd300e703750>>
 * @relayHash cee8aef42c4809bf7b8650e7551b3954
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 181cde876f75df92feb4611c6fe60fe79917211ed1f2052dda73533c7ff2635e

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ActivitiesFilterType = "AND" | "OR" | "%future added value";
export type ActivityFilter = {
  actors?: ReadonlyArray<string> | null;
  arguments?: ActivityFilterArgs | null;
  collabContextId?: string | null;
  rootContainerIds?: ReadonlyArray<string> | null;
  type?: ActivitiesFilterType | null;
};
export type ActivityFilterArgs = {
  containerIds?: ReadonlyArray<string> | null;
  earliestStart?: AGG$DateTime | null;
  eventTypes?: ReadonlyArray<string> | null;
  latestStart?: AGG$DateTime | null;
  objectTypes?: ReadonlyArray<string> | null;
  products?: ReadonlyArray<string> | null;
  transitions?: ReadonlyArray<TransitionFilter> | null;
};
export type TransitionFilter = {
  from: string;
  to: string;
};
export type SmartsRecommendationsQuery = {
  context: SmartsContext;
  excludeInactive?: boolean | null;
  excludeSelf?: boolean | null;
  maxNumberOfResults?: number | null;
  modelRequestParams: SmartsModelRequestParams;
  requestingUserId: string;
  sessionId?: string | null;
};
export type SmartsContext = {
  additionalContextList?: ReadonlyArray<SmartsKeyValue> | null;
  containerId?: string | null;
  excludeCollaboratorRecommendations?: boolean | null;
  objectId?: string | null;
  product?: string | null;
  tenantId: string;
  userId: string;
};
export type SmartsKeyValue = {
  key: string;
  value: string;
};
export type SmartsModelRequestParams = {
  caller: string;
  experience: string;
  featureServiceModel?: string | null;
};
export type singlePersonKnowledgeCardRelayQuery$variables = {
  filter?: ActivityFilter | null;
  first: number;
  recommendationsQuery: SmartsRecommendationsQuery;
  reportingLinesAaid: string;
  reportingLinesOrgId: string;
  reportingLinesSiteId: string;
  singleUserAccountId: string;
  singleUserRequestingUserId: string;
  singleUserTenantId: string;
};
export type singlePersonKnowledgeCardRelayQuery$data = {
  readonly activity: {
    readonly workedOn: {
      readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_workedOn">;
    };
  } | null;
  readonly knowledgeDiscovery: {
    readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_reportingLines" | "singlePersonKnowledgeCardRelay_user">;
  } | null;
  readonly smarts: {
    readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_smarts">;
  } | null;
};
export type singlePersonKnowledgeCardRelayQuery = {
  response: singlePersonKnowledgeCardRelayQuery$data;
  variables: singlePersonKnowledgeCardRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationsQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesAaid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesOrgId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesSiteId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserAccountId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserRequestingUserId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserTenantId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "recommendationsQuery",
    "variableName": "recommendationsQuery"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "singleUserAccountId"
  },
  {
    "kind": "Variable",
    "name": "requestingUserId",
    "variableName": "singleUserRequestingUserId"
  },
  {
    "kind": "Variable",
    "name": "tenantId",
    "variableName": "singleUserTenantId"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "aaid",
    "variableName": "reportingLinesAaid"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "reportingLinesOrgId"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "reportingLinesSiteId"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v14/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v14/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v14/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v20 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v14/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v13/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v19/*: any*/)
    ]
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "url"
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v24 = [
  (v23/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      (v18/*: any*/)
    ]
  }
],
v25 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v26 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v27 = [
  (v21/*: any*/),
  (v18/*: any*/)
],
v28 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
],
v29 = {
  "kind": "ScalarField",
  "name": "name"
},
v30 = {
  "kind": "ScalarField",
  "name": "picture"
},
v31 = {
  "kind": "ScalarField",
  "name": "email"
},
v32 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v33 = [
  (v32/*: any*/)
],
v34 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v29/*: any*/),
      (v30/*: any*/),
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": (v33/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "singlePersonKnowledgeCardRelay_workedOn"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_smarts"
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_user"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_reportingLines"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "singlePersonKnowledgeCardRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceDatabaseLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceDatabase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceEmbedLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceEmbed"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ConfluenceFooterComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ConfluenceInlineComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "TownsquareGoal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "TownsquareProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "TownsquareComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/)
                                ],
                                "type": "JiraIssue"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v24/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v24/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "TrelloBoard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "TrelloCard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "DevOpsDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "DevOpsDesign"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "ExternalRemoteLink"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "MercuryFocusArea"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "MercuryPortfolio"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "RadarPosition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "RadarView"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "CompassComponent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "href"
                                  }
                                ],
                                "type": "BitbucketPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "loomUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "AssetsObject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "AssetsObjectType"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "AssetsSchema"
                              },
                              (v19/*: any*/)
                            ]
                          },
                          (v18/*: any*/)
                        ]
                      },
                      (v18/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "SmartsRecommendedUser",
            "kind": "LinkedField",
            "name": "recommendedUser",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v31/*: any*/),
                      {
                        "concreteType": "AtlassianAccountUserExtendedProfile",
                        "kind": "LinkedField",
                        "name": "extendedProfile",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  },
                  (v18/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "singleUser",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryUserProfile",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "department"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "location"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "organization"
                      },
                      {
                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                        "kind": "LinkedField",
                        "name": "thirdPartyIntegrations",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "externalId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "integrationId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "product"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeDiscoverySingleUser"
              }
            ]
          },
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "reportingLines",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v34/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": true,
                    "selections": (v34/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": true,
                    "selections": (v34/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "peers",
                    "plural": true,
                    "selections": (v34/*: any*/)
                  }
                ],
                "type": "KnowledgeDiscoveryReportingLines"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "181cde876f75df92feb4611c6fe60fe79917211ed1f2052dda73533c7ff2635e",
    "metadata": {},
    "name": "singlePersonKnowledgeCardRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3b96d2345c405f05720744ecd857cd6a";

export default node;
